import { Release } from '@/api/api';
import { CPU_ARCHITECTURES, IS_FETCHING_CPU_ARCHITECTURES } from '../types';

export default {
  state: () => ({
    architectures: [],
    isFetching: false,
  }),

  getters: {
    [CPU_ARCHITECTURES]({ architectures = [] }) {
      return architectures;
    },
    [IS_FETCHING_CPU_ARCHITECTURES]({ isFetching }) {
      return isFetching;
    },
  },

  mutations: {
    [CPU_ARCHITECTURES](state, architectures) {
      state.architectures = architectures;
    },
    [IS_FETCHING_CPU_ARCHITECTURES](state, value) {
      state.isFetching = value;
    },
  },

  actions: {
    [CPU_ARCHITECTURES]({ commit, state }) {
      if (state.architectures.length || state.isFetching) return;
      commit(IS_FETCHING_CPU_ARCHITECTURES, true);

      return Release.getCpuArchitectures()
        .then(({ architectures = [] }) => {
          commit(CPU_ARCHITECTURES, architectures);
        })
        .catch(() => {})
        .finally(() => commit(IS_FETCHING_CPU_ARCHITECTURES, false));
    },
  },
};
